import type {
  DiversificationConstraint,
  ModelConstraint,
  Piece,
} from '@/types/api/constraints'

import { PiecewiseConstraintType } from '@moment/horizon-data-access/proposal'

import { getFormattedFieldName, renderPieceBound } from './utils'

// Each tier child's piece by child id, so a tier child's verdict can name its tier.
export function indexTierPieces(
  rules: Iterable<ModelConstraint | undefined>,
): ReadonlyMap<string, Piece> {
  const byChildId = new Map<string, Piece>()
  for (const rule of rules) {
    if (rule?.type !== PiecewiseConstraintType.piecewise) continue
    for (const piece of rule.pieces) {
      for (const child of piece.constraints) {
        if (child.id) byChildId.set(child.id, piece)
      }
    }
  }
  return byChildId
}

export function renderEqualWeightLabel({
  constraint,
  piece,
}: {
  constraint: DiversificationConstraint
  piece: Piece | undefined
}): string {
  const label = `Equal weight per ${getFormattedFieldName(constraint.field)}`
  const bound = piece ? renderPieceBound(piece) : ''
  return bound ? `${label} ${bound}` : label
}
